module.exports = __webpack_public_path__ + "img/pricing.b822d4f3.svg";